import React from 'react';
import CasinoContainer from '../../../../components/casino/CasinoContainer';
import LangLinkContent from './LangLinkContent';

export default function LangLinks() {
  return (
    <CasinoContainer title={'Languages ​​and links for casinos'}>
      <LangLinkContent />
    </CasinoContainer>
  );
}
